import { Injectable } from '@angular/core';
import { MissingTranslationHandler, TranslateCompiler, TranslateParser, TranslateService, TranslateStore } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Language, LocalizationService, LocalizationSettings } from './localization.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Discussions_LocalizationService } from './Discussions.localization.service';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Addresses_LocalizationService } from './Addresses.localization.service';
import { AsnOrders_LocalizationService } from './AsnOrders.localization.service';
import { Attachments_LocalizationService } from './Attachments.localization.service';
import { Carriers_LocalizationService } from './Carriers.localization.service';
import { Instructions_LocalizationService } from './Instructions.localization.service';
import { ExcelOrderImport_LocalizationService } from './ExcelOrderImport.localization.service';
import { Locations_LocalizationService } from './Locations.localization.service';
import { Lots_LocalizationService } from './Lots.localization.service';
import { LoadContainers_LocalizationService } from './LoadContainers.localization.service';
import { Owners_LocalizationService } from './Owners.localization.service';
import { PurchaseOrders_LocalizationService } from './PurchaseOrders.localization.service';
import { Invoices_LocalizationService } from './Invoices.localization.service';
import { Notifications_LocalizationService } from './Notifications.localization.service';
import { Materials_LocalizationService } from './Materials.localization.service';
import { DockAppointments_LocalizationService } from './DockAppointments.localization.service';
import { SerialNumbers_LocalizationService } from './SerialNumbers.localization.service';
import { SalesOrders_LocalizationService } from './SalesOrders.localization.service';
import { Inventory_LocalizationService } from './Inventory.localization.service';

@Injectable({
  providedIn: 'root'
})
export class FootPrintPortalManager_LocalizationService
  extends LocalizationService<{  }> {

  public FootPrintPortalManager: FootPrintPortalManager_LocalizationService = this;

  public override get settings(): LocalizationSettings {
    return {"default":"","languages":[]}
  }
  
  private _referencedServices: LocalizationService<any>[] = [];

  constructor(
    httpClient: HttpClient,
    compiler: TranslateCompiler,
    parser: TranslateParser,
    missingHandler: MissingTranslationHandler,
    public Discussions: Discussions_LocalizationService,
    public Utilities: Utilities_LocalizationService,
    public Addresses: Addresses_LocalizationService,
    public AsnOrders: AsnOrders_LocalizationService,
    public Attachments: Attachments_LocalizationService,
    public Carriers: Carriers_LocalizationService,
    public Instructions: Instructions_LocalizationService,
    public ExcelOrderImport: ExcelOrderImport_LocalizationService,
    public Locations: Locations_LocalizationService,
    public Lots: Lots_LocalizationService,
    public LoadContainers: LoadContainers_LocalizationService,
    public Owners: Owners_LocalizationService,
    public PurchaseOrders: PurchaseOrders_LocalizationService,
    public Invoices: Invoices_LocalizationService,
    public Notifications: Notifications_LocalizationService,
    public Materials: Materials_LocalizationService,
    public DockAppointments: DockAppointments_LocalizationService,
    public SerialNumbers: SerialNumbers_LocalizationService,
    public SalesOrders: SalesOrders_LocalizationService,
    public Inventory: Inventory_LocalizationService
    ) {
    super(
      new TranslateService(
        new TranslateStore(),
        new TranslateHttpLoader(httpClient, '../assets/i18n/FootPrintPortalManager/', '.json'),
        compiler,
        parser,
        missingHandler,
        true,
        true,
        false,
        ''));

    this._referencedServices.push(this.Discussions);

    this._referencedServices.push(this.Utilities);

    this._referencedServices.push(this.Addresses);

    this._referencedServices.push(this.AsnOrders);

    this._referencedServices.push(this.Attachments);

    this._referencedServices.push(this.Carriers);

    this._referencedServices.push(this.Instructions);

    this._referencedServices.push(this.ExcelOrderImport);

    this._referencedServices.push(this.Locations);

    this._referencedServices.push(this.Lots);

    this._referencedServices.push(this.LoadContainers);

    this._referencedServices.push(this.Owners);

    this._referencedServices.push(this.PurchaseOrders);

    this._referencedServices.push(this.Invoices);

    this._referencedServices.push(this.Notifications);

    this._referencedServices.push(this.Materials);

    this._referencedServices.push(this.DockAppointments);

    this._referencedServices.push(this.SerialNumbers);

    this._referencedServices.push(this.SalesOrders);

    this._referencedServices.push(this.Inventory);
    
    this.initialize();

  }

  public override setLanguage(lang: Language): void{
    super.setLanguage(lang);
  
    for (let i of this._referencedServices){
      i.setLanguage(lang);
    }
  }
}